import React from 'react';
import { connect } from 'react-redux';
import _, { filter } from 'lodash';
import BasePage from './BasePage';
import IconCard from '../dashboard/IconCard';
import { ButtonToolbar, Table, Card, Badge, ButtonGroup, InputGroup, DropdownButton, Row, Col, Dropdown, Button, Container } from 'react-bootstrap'
import FuseInputBox from '../inputFields/FuseInputBox';

class HomeDashboardPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = { dashboardInformation: [] };
  }

  static defaultProps = {}

  buildCards = () =>{    
    var values = {}
    var billingEntitySearchString='';
    if (!_.isEmpty(this.state.selectedEntity)){
      values["billing_entity_code"] = this.state.selectedEntity
      billingEntitySearchString='~billing_entity_code^='+this.state.selectedEntity
    }
    var yesterday = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
    return <Row>  
      <IconCard 
        icon="fa-exclamation-triangle"
        variant="danger"
        title="Card Example"
        description="Users on System"
        tableName="dbo.abpUsers"
        aggregateCol="id"
        aggregate="COUNT"
        values={{}}
        //url={"#/generic?screenId=300&parent=BillingTemplateMenu&searchString=approval_status^=IN_EDIT" + billingEntitySearchString}
      />
  </Row>;
  }

  
  buildFilters = () =>{
    return <>
    {/* <table className="mb-2 filters-table"> 
      <tbody>
        <tr>
          <td>Billing Entity</td>
          <td>
            <FuseInputBox type="dropdown"
              dropKeyColumn="code"
              dropValueColumn="name"
              dropDownValues={this.state.billingEntities}
              value={this.state.selectedEntity}
              onChange={(val) => {
                this.setState({ 
                  ...this.state,
                  selectedEntity: val,
                   selectedGroup: null,
                    selectedGroupUser: null });
            }}
            editable/>
          </td>
          <td><Button variant="info" onClick={()=>{this.setState();}}><i className="fa fa-sync" /></Button></td>
        </tr>
      </tbody>
    </table> */}
    </>;
  }

  render() {
    return (
      <div>
        <br/>
          <h3 class="top-light">Welcome {this.props.auth.user.name} {this.props.auth.user.surname}.</h3>
        <br/>
          {/* {this.buildFilters()}
          <Container fluid>
            {this.buildCards()}
          </Container> */}
      </div>
    );
  }    

  componentDidMount = () =>{
    //this.fetchBillingEntityItems();
  }

 }

const mapStateToProps = (state) => {
  return {
    fetchingData: state.fetchingData === true,
    auth: state.auth,
  };
}

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({

  })
)(HomeDashboardPage);